/* eslint-disable */
// @ts-nocheck

declare let fbq;

export function initializeFacebookPixel(id: string) {
  // @ts-ignore
  !function(f, b, e, v, n, t, s) {
    if ((<any>f).fbq) return;
    n = (<any>f).fbq = function() {
      n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!(<any>f)._fbq) (<any>f)._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window,
    document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', id);
}
